module.exports = __webpack_public_path__ + "media/Image_De-Oldify.eca62e23.webm";